import React, { useState } from 'react';
import logo from "../img/logo.png";
import "../css/SignUp.css";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export default function SignUp() {
    const navigate = useNavigate();
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [password, setPassword] = useState("");
    const [about, setAbout] = useState("");
    const [rkey, setRkey] = useState("");
    const [aboutCount, setAboutCount] = useState(0);
    const [hideSignUp, setHideSignUp] = useState(false);
    const [loading, setLoading] = useState(false);

    const notifyA = (msg) => toast.error(msg);
    const notifyB = (msg) => toast.success(msg);

    const postData = () => {
        setLoading(true);

        const trimmedName = name.trim();
        const cleanPhone = phone.replace(/\D/g, '');
        const trimmedRKey = rkey.trim().toLowerCase();
        const trimmedAbout = about.trim();

        if (!trimmedName || !cleanPhone || !password || !trimmedAbout || !trimmedRKey) {
            setLoading(false);
            notifyA("Please fill in all fields (Name, Phone number, Password, About, and RKey)");
            return;
        }

        if (cleanPhone.length !== 10) {
            setLoading(false);
            notifyA("Please enter a valid 10-digit phone number");
            return;
        }

        if (password.length < 6) {
            setLoading(false);
            notifyA("Password must be at least 6 characters long");
            return;
        }

        if (trimmedAbout.length > 1000) {
            setLoading(false);
            notifyA("About cannot exceed 1000 characters");
            return;
        }

        fetch("/signup", {
            method: "post",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                name: trimmedName,
                phone: cleanPhone,
                password,
                about: trimmedAbout,
                rkey: trimmedRKey
            })
        })
        .then(res => res.json())
        .then(data => {
            setLoading(false);
            if (data.error) {
                notifyA(data.error);
            } else {
                notifyB(data.message || "Registered successfully");
                navigate("/signin");
            }
        })
        .catch(err => {
            setLoading(false);
            notifyA("Network error. Please try again.");
            console.error(err);
        });
    };

    return (
        <div className='signUp'>
            <div className="form-container">
                <div className="form">
                    <img className='signUpLogo' src={logo} alt="Logo" />
                    <h1 style={{color: "white"}} className='appName'>TheMediFile</h1>
                    <p className='pointLine' style={{ marginTop: "-22px" }}>Store your medical details on internet</p>

                    <div className='actionButtons' style={{ display: 'flex', flexDirection: 'column', alignItems: "center", gap: 12, justifyContent: 'center', width: '100%', marginTop: 12 }}>
                        <button id='signUpToggle' onClick={() => setHideSignUp(!hideSignUp)}>
                            {hideSignUp ? 'Hide Sign Up Form' : 'Create An Account (Sign Up)'}
                        </button>
                    </div>

                    <div style={{ backgroundColor: "black", borderRadius: "15px", padding: "15px" }} className={hideSignUp ? '' : 'signupHide'}>
                        <div>
                            <input
                                style={{border: "1px solid #d39797", width: "100%"}}
                                className='mainInputs'
                                type="text"
                                name="name"
                                id='name'
                                placeholder='Name'
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                maxLength={100}
                            />
                        </div>
                        <div>
                            <input
                                style={{border: "1px solid #d39797", width: "100%"}}
                                className='mainInputs'
                                type="tel"
                                name="phone"
                                id='phone'
                                placeholder='Phone Number (10 digits)'
                                value={phone}
                                onChange={(e) => {
                                    const digits = e.target.value.replace(/\D/g, '').slice(0, 10);
                                    setPhone(digits);
                                }}
                                maxLength={10}
                            />
                        </div>
                        <div>
                            <input
                                style={{border: "1px solid #d39797", width: "100%"}}
                                className='mainInputs'
                                type="text"
                                name="rkey"
                                id='rkey'
                                placeholder='RKey (Registration Secret Key)'
                                value={rkey}
                                onChange={(e) => setRkey(e.target.value.toLowerCase().replace(/\s+/g, ''))}
                                maxLength={100}
                            />
                        </div>
                        <div>
                            <input
                                style={{border: "1px solid #d39797", width: "100%"}}
                                className='mainInputs'
                                type="password"
                                name="password"
                                id='password'
                                placeholder='Password (min 6 characters)'
                                value={password}
                                onChange={(e) => setPassword(e.target.value.slice(0, 120))}
                                maxLength={120}
                            />
                        </div>
                        <div>
                            <textarea
                                style={{border: "1px solid #d39797", width: "100%", minHeight: 120 }}
                                className='mainInputs'
                                name="about"
                                id='about'
                                placeholder='About - Tell people about yourself'
                                value={about}
                                onChange={(e) => {
                                    setAbout(e.target.value);
                                    setAboutCount(e.target.value.length);
                                }}
                                maxLength={1000}
                            />
                            <div style={{ textAlign: 'right', fontSize: 12, color: '#666' }}>{aboutCount}/1000</div>
                        </div>

                        <div style={{ fontSize: "15px", marginBottom: "15px", marginTop: "15px" }}>
                            By tapping "Agree & Sign Up", you agree to the{' '}
                            <a href="/terms-of-use" target="_blank" rel="noopener noreferrer" style={{ color: 'yellow', backgroundColor: "black", textDecoration: "underline" }}>
                                Terms of Use
                            </a>{' '}
                            and{' '}
                            <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ color: 'yellow', backgroundColor: "black", textDecoration: "underline" }}>
                                Privacy Policy
                            </a>
                        </div>
                        <button type="button" id='submit-btn' onClick={postData} disabled={loading}>
                            {loading ? <span className="btn-spinner" /> : 'Agree & Sign Up'}
                        </button>
                    </div>

                    <button id='signInToggle' onClick={() => navigate('/signin')}>Login</button>
                    <br />
                    <hr />
                    <br />
                    <div style={{ backgroundColor: "black", display: "flex", flexDirection: "column", alignItems: "center", marginTop: "10px", width: "100%" }}>
                        <p>a <b>Subodh Sathe</b> creation</p>
                        <b>TheMediFile &copy; 2026</b>
                        <a href="/support" target="_blank" rel="noopener noreferrer" style={{ color: 'yellow', backgroundColor: "black", textDecoration: "underline", marginTop: 6, display: 'inline-block' }}>Contact Us</a>
                        <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ color: 'yellow', backgroundColor: "black", textDecoration: "underline", marginTop: 6, display: 'inline-block' }}>Privacy Policy</a>
                        <a href="/csae-standards" target="_blank" rel="noopener noreferrer" style={{ color: 'yellow', backgroundColor: "black", textDecoration: "underline", marginTop: 6, display: 'inline-block', marginBottom: "15px" }}>CSAE Standards</a>
                    </div>
                </div>
            </div>
        </div>
    );
}
